@if (compatibleBrowser()) {
  <div class="relative" [ngStyle]="{ height: '100dvh', width: '100vw' }">
    @if (offline()) {
      <div class="offline">
        <vl-title
          [big]="true"
          [white]="true"
          style="position: fixed; bottom: 100px; left: 50px;"
          [prefix]="'system.network_error' | trans"
        ></vl-title>
        <vl-title
          [big]="true"
          [white]="true"
          style="position: fixed; bottom: 50px; left: 50px;"
          [prefix]="'system.check_connexion' | trans"
        ></vl-title>
      </div>
    }

    <router-outlet #outlet="outlet"></router-outlet>


  </div>
} @else {
  <div
    class="incompatible flex-container"
    style="
            display: flex;
            align-content: center;
            justify-content: center;
            align-items: center;
        "
    [ngStyle]="{ height: '100dvh', width: '100vw' }">

    <div class="flex-container" style="width:500px">
      <vl-just-logo
        style="margin-bottom: 50px;"
        [simple]="false"
        [color]="'rgba(223,0,61,1)'"
        [width]="'200px'"
        [height]="'200px'"
      ></vl-just-logo>

      <vl-title style="margin-bottom: 20px;" [big]="true" [white]="true"
                [prefix]="'system.browser_version' | trans"></vl-title>
      <vl-title style="margin-bottom: 20px;" [white]="true"
                [prefix]="'system.browser_version_update' | trans"></vl-title>

      <div class="caption  flex-container-row clickable" style="margin-bottom: 10px; align-items: center;"
           (click)="onGo('https://www.google.com/intl/fr/chrome/gsem/download/?brand=ORZA&ds_kid=43700075934932916&gad_source=1&gclid=Cj0KCQiAqsitBhDlARIsAGMR1RgbQeE5X6UCM_qwWgSmeqRbzutK-CDYtMoujSBpbwOypDhFX6yMABcaAra3EALw_wcB&gclsrc=aw.ds')">
        Chrome >= 120&nbsp;<mat-icon>link</mat-icon>
      </div>
      <div class="caption  flex-container-row clickable" style="margin-bottom: 10px; align-items: center;"
           (click)="onGo('https://www.mozilla.org/fr/firefox/new/')">Firefox >= 120&nbsp;<mat-icon>link
      </mat-icon>
      </div>
      <div class="caption  flex-container-row clickable" style="margin-bottom: 10px; align-items: center;"
           (click)="onGo('https://www.microsoft.com/fr-fr/edge/download?form=MA13FJ')">Edge >= 120&nbsp;<mat-icon>
        link
      </mat-icon>
      </div>
    </div>

  </div>
}


